import { Text } from "@/components/ui/text";
import { Icon } from "@/components/ui/icon";

import { ColorItemReturnVariantProps } from "./color-item.variants";

export type ColorItemContentProps = {
  label: string;
  value: string;
  textColor: string;
  styles: ColorItemReturnVariantProps;
  onCopyToClipboard: (value: string) => void;
};

function ColorItemContent(props: ColorItemContentProps) {
  const { label, value, textColor, styles, onCopyToClipboard } = props;

  return (
    <div className={styles.contentItem()}>
      <Text
        tag="span"
        size="bodyMedium"
        className={styles.legend()}
        style={{ color: textColor }}
      >
        {label}
      </Text>
      <button
        type="button"
        title="Copy to clipboard"
        onClick={() => onCopyToClipboard(value)}
        className={styles.copyButton()}
        style={{ color: textColor }}
      >
        <Text
          tag="span"
          size="bodyMedium"
          className={styles.value()}
          style={{ color: textColor }}
        >
          {value}
        </Text>
        <Icon name="copy" className={styles.copyIcon()} />
      </button>
    </div>
  );
}

export default ColorItemContent;
